import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import styles from "../../styles/components/product/FavoritesList.module.css";

const FavoritesListSkeleton = () => {
  return (
    <div className={styles.favoriteCard}>
      <Skeleton className={styles.skeletonMedia} />
      <div className={styles.favoriteBody}>
        <Skeleton height={14} width="90%" />
        <Skeleton height={12} width="55%" />
        <Skeleton height={16} width="35%" />
      </div>
    </div>
  );
};

export default FavoritesListSkeleton;
